import React, { useState } from "react";
import { Button, Card } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import HeaderModal from "components/modal/HeaderModal";
import { Send, CircleCheck } from "lucide-react";
import EmployeeSelector from "./EmployeeSelector";
import { CATEGORY_CONFIG } from "variables/constants";

const AwardCategoryCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const openModal = (key) => {
    setSelectedCategory(CATEGORY_CONFIG[key]);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null);
  };

  const categoryKeys = Object.keys(CATEGORY_CONFIG);

  return (
    <HeaderComponent
      title="Award Categories"
      titleClass="text-[16px] font-medium"
      description="Select an award category to nominate a team member"
      descriptionClass="text-sm"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {categoryKeys.map((key) => {
          const category = CATEGORY_CONFIG[key];
          const Icon = category.icon;

          return (
            <Card
              key={category.id}
              onClick={() => openModal(key)}
              className={`card-theme ${category.colorClass} rounded-xl cursor-pointer hover:shadow-lg transition-all`}
            >
              <div className="space-y-4">
                <div className="flex flex-col items-start gap-3">
                  <div className="icon-style p-3 text-white">
                    <Icon className="h-6 w-6" />
                  </div>

                  <h4 className="card-text text-base">{category.title}</h4>

                  <p className="text-[13px] text-muted-foreground">
                    {category.description}
                  </p>
                </div>

                <button className="h-8 rounded-2xl w-full icon-style !bg-gradient-to-r text-white inline-flex items-center justify-center font-semibold gap-3">
                  <Send className="h-4 w-4" /> Nominate
                </button>
              </div>
            </Card>
          );
        })}
      </div>

      {isModalOpen && selectedCategory && (
        <HeaderModal
          open={isModalOpen}
          onClose={closeModal}
          title={`Nominate for ${selectedCategory.title}`}
          titleClass="text-lg font-semibold"
          labelIcon={
            <div className={`card-theme ${selectedCategory.colorClass} invisible`}>
              <div className="icon-style p-2 text-white visible">
                {selectedCategory.icon &&
                  React.createElement(selectedCategory.icon, {
                    className: "h-5 w-5",
                  })}
              </div>
            </div>
          }
          description={selectedCategory.description}
          descriptionClass="text-sm"
          bgcolor="white"
          width={550}
          footer={
            <div className="p-4 flex justify-end gap-2">
              <Button
                className="inline-flex items-center justify-center gap-2 rounded-xl text-sm text-gray-800 h-9 px-4"
                onClick={closeModal}
              >
                Cancel
              </Button>

              <div className={`card-theme ${selectedCategory.colorClass} invisible`}>
                <Button
                  icon={<CircleCheck size={16} />}
                  className="!bg-gradient-to-r icon-style inline-flex items-center justify-center visible text-white p-4 h-9 font-medium"
                >
                  Submit Nomination
                </Button>
              </div>
            </div>
          }
        >
          <EmployeeSelector />
        </HeaderModal>
      )}
    </HeaderComponent>
  );
};

export default AwardCategoryCard;
